import moment from 'moment';
const dateFormat = 'MMMM DD YYYY';
export class InsuredBeneficiaryModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    get fullName() {
        return `${this.firstName} ${this.middleName ? this.middleName : ''} ${this.lastName}`;
    }
    get formattedBirthDate() {
        const birthDate = this.birthdate;
        if (!birthDate) {
            return 'None';
        }
        return moment(birthDate).format(dateFormat);
    }
}
